var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.569,
    height: 41.569,
    viewBox: "0 0 41.569 41.569",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_994",
    "data-name": "Group 994",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_993",
    "data-name": "Group 993",
    transform: "translate(11.203 9.105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M786.7,410h3.976v12.772H786.7Zm1.989-6.347a2.3,2.3,0,1,1-2.3,2.3,2.3,2.3,0,0,1,2.3-2.3m4.478,19.118h3.968v-6.317c0-1.666.315-3.279,2.381-3.279,2.034,0,2.063,1.9,2.063,3.387v6.209h3.967v-7c0-3.44-.741-6.083-4.76-6.083a4.173,4.173,0,0,0-3.759,2.063h-.052V410h-3.809Z",
    transform: "translate(-786.379 -403.651)",
    fill: "#17447e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M786.966,387.235a20.784,20.784,0,1,0,20.785,20.784A20.808,20.808,0,0,0,786.966,387.235Zm0,38.9a18.118,18.118,0,1,1,18.119-18.119A18.139,18.139,0,0,1,786.966,426.138Z",
    transform: "translate(-766.182 -387.235)",
    fill: "#17447e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.dfa17bbef723f22dbdf2afacc4e29594.svg";
export { ForwardRef as ReactComponent };